import { render, staticRenderFns } from "./ImpressionsCampaignRanking.vue?vue&type=template&id=6ea588b1"
import script from "./ImpressionsCampaignRanking.vue?vue&type=script&lang=js"
export * from "./ImpressionsCampaignRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports